var map = {
	"./pr-1.png": "d190",
	"./pr-2.png": "686b",
	"./pr-3.png": "6a21",
	"./pr-4.png": "0c32",
	"./pr-5.png": "937f",
	"./pr-6.png": "b5ec",
	"./pr-7.png": "f154",
	"./pr-8.png": "981d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f5e5";